import { render, staticRenderFns } from "./CallRider.vue?vue&type=template&id=48647437&scoped=true"
import script from "./CallRider.vue?vue&type=script&lang=js"
export * from "./CallRider.vue?vue&type=script&lang=js"
import style0 from "./CallRider.vue?vue&type=style&index=0&id=48647437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48647437",
  null
  
)

export default component.exports